import InnmaxMap2 from '@shared/InnmaxMap2'
import { Map } from 'maplibre-gl'
import styled from 'styled-components'
import { useDashboardContext } from '../../Provider'

const Controllers = ({
  avaliableControllers = [],
}: {
  onFilterControlClick?: () => void
  onLayerControlClick?: () => void
  activedFilter?: boolean
  avaliableControllers?: 'zoom'[]
}) => {
  const { mapInstance } = useDashboardContext()

  return (
    <Div>
      <div className="flex flex-col gap-[20px]">
        {/* <InnmaxMap2.PlaceSearchControl
          onPlaceSelected={(place: google.maps.places.PlaceResult) => {
            if (place.geometry && mapInstance?.map instanceof google.maps.Map) {
              mapInstance?.map?.fitBounds(
                new google.maps.LatLngBounds(place?.geometry?.viewport)
              )
            }
          }}
        />
        <InnmaxMap2.FilterControl
          maplibre={{
            onClick: props.onFilterControlClick,
            active: props.activedFilter,
          }}
          google={{
            onClick: props.onFilterControlClick,
            active: props.activedFilter,
          }}
        />
        <InnmaxMap2.LayerControl
          maplibre={{
            onClick: props.onLayerControlClick,
          }}
          google={{
            onClick: props.onLayerControlClick,
          }}
        /> */}
      </div>
      {avaliableControllers.includes('zoom') && (
        <div className="pointer-events-auto">
          <InnmaxMap2.ZoomControl
            onZoomIn={() => {
              if (mapInstance?.map instanceof Map) {
                mapInstance?.map.flyTo({
                  zoom: (mapInstance?.map.getZoom() || 0) + 1,
                })
              }
              if (mapInstance?.map instanceof google.maps.Map) {
                mapInstance?.map.setZoom((mapInstance?.map.getZoom() || 0) + 1)
              }
            }}
            onZoomOut={() => {
              if (mapInstance?.map instanceof google.maps.Map) {
                mapInstance?.map.setZoom((mapInstance?.map.getZoom() || 0) - 1)
              }
              if (mapInstance?.map instanceof Map) {
                mapInstance?.map.flyTo({
                  zoom: (mapInstance?.map.getZoom() || 0) - 1,
                })
              }
            }}
          />
        </div>
      )}
    </Div>
  )
}

const Div = styled.div`
  margin-top: 60px;
  grid-area: controllers;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding-bottom: 15px;
`
export default Controllers
